export default __webpack_public_path__ + "static/media/confesiones4.9f5eac64.png";